let abortController = new AbortController();
const abortControllerHandler = () => {
  const abortCurrentRequest = (message?: string) => {
    abortController.abort(message || "Request aborted");
    resetAbortController();
  };

  const resetAbortController = () => {
    abortController = new AbortController();
  };

  const getAbortController = () => {
    return abortController;
  };

  return {
    abortCurrentRequest,
    resetAbortController,
    getAbortController,
  };
};

export default abortControllerHandler;
